// extracted by mini-css-extract-plugin
export default {"tooltip":"Lo-z","sharingV2":"Mo-z","sharingIconsV2":"No-z","links":"Oo-z","link":"Po-z","facebookV2":"Qo-z","twitterV2":"Ro-z","pinterestV2":"So-z"};